<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <a href="#" @click="openNextStage()">
      <b-row v-if="item.id">
        <b-col>
          <span v-if="item.willExpire" class="task-lane-item-id">
            <div class="cargo-priority">#{{ item.id }}</div>
          </span>
          <span v-else class="task-lane-item-id">#{{ item.id }}</span>
        </b-col>

        <b-col>
          <div class="time">
            <div class="d-inline pt-3">
              {{ item.elapsedTime }}
            </div>
            <div class="d-inline ml-1">
              <i class="tim-icons icon-time-alarm"></i>
            </div>
            <div v-if="item.willExpire" class="d-inline ml-1">
              <b-icon
                icon="exclamation-circle-fill"
                variant="danger"
                v-b-tooltip.hover
                title="Esta carga está expirando em breve"
              ></b-icon>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="pre-formatted">{{ item.text }}</div>
    </a>

    <cargo-expense-kanban-edit
      ref="kanbanEditModal"
      :id="item.id.toString()"
      @confirmEdit="refreshData"
    >
    </cargo-expense-kanban-edit>
  </div>
</template>

<script>
export default {
  name: "CargoExpenseCard",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CargoExpenseKanbanEdit: () =>
      import(
        "@/pagesRms/trackingShippingCompany/cargoExpenseKanban/CargoExpenseKanbanEdit.vue"
      ),
  },
  props: ["item"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  methods: {
    openNextStage() {
      this.$refs.kanbanEditModal.show();
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>


<style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
